import React, { useState, useEffect } from 'react';
import styles from "../Stadistics.module.css";
import { calcularEdad } from '../../../../utils/funciones';
import axios from 'axios';
import { URL } from '../../../../link';

const Escudo = ({
  detailUser,
  userDefault
}) => {
  const defaultValues = {
    foto: userDefault,
    nombre: "Sin nombre",
    direccion: "Sin dirección",
    origen: "Sin origen",
    fondo: "Sin equipo",
    altura: 0,
    peso: 0,
    pie: "",
    scores: [{ valor: 0 }]
  };

  const userData = { ...defaultValues, ...detailUser };
  const [estrellas, setEstrellas] = useState(0);
  const [numEvaluaciones, setNumEvaluaciones] = useState(0);

  const getPromedioEstrellas = async () => {
    try {
      const response = await axios.get(`${URL}/entrenamiento/promedio/${detailUser.id}`);
      setEstrellas(response.data);
      setNumEvaluaciones(response.data.numEvaluaciones || 0);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (detailUser?.id) getPromedioEstrellas();
  }, [detailUser?.id]);

  return (
    <div className={styles.fondoEscudo}>
      <div className={styles.contFoto}>
        <img
          className={styles.foto}
          src={userData.foto || userDefault}
          alt=""
        />

        {/* Información básica */}
        <h3 className={styles.name}>{userData.nombre}</h3>
        <h4 className={styles.direccion}>
          {userData.direccion}, {userData.origen}
        </h4>
        <h3 className={styles.name}>{userData.fondo || "Sin equipo"}</h3>

        {/* Estrellas de promedio - Nueva visualización */}
        <div className={styles.estrellasPromedio}>
          <span className={styles.promedioValor}>
            {estrellas?.promedio?.toFixed(1) || 0}
          </span>
          <span className={styles.starIcon}>★</span>
          <span className={styles.promedioValor}>
            ({estrellas?.totalEstrellas || 0} evaluaciones)
          </span>
        </div>

        {/* Datos físicos - primera fila */}
        <div className={styles.contUserInfo}>
          <div className={styles.userInfo}>
            <div className={styles.info}>
              <h3 className={styles.dataName}>EDAD</h3>
              <h4 className={styles.dataInfo}>
                {calcularEdad(userData.dia, userData.mes, userData.anio)} años
              </h4>
            </div>
          </div>
          <div className={styles.userInfo}>
            <div className={styles.infoB}>
              <h3 className={styles.dataName}>ALTURA</h3>
              <h4 className={styles.dataInfo}>{userData.altura / 100}m</h4>
            </div>
          </div>
        </div>

        {/* Datos físicos - segunda fila */}
        <div className={styles.contUserInfo}>
          <div className={styles.userInfo}>
            <div className={styles.info}>
              <h3 className={styles.dataName}>PESO</h3>
              <h4 className={styles.dataInfo}>{userData.peso}kg</h4>
            </div>
          </div>
          <div className={styles.userInfo}>
            <div className={styles.infoB}>
              <h3 className={styles.dataName}>PIE</h3>
              <h4 className={styles.dataInfo}>
                {userData.pie?.slice(0, 3).toUpperCase()}
              </h4>
            </div>
          </div>
        </div>

        {/* BSD Score */}
        <div className={styles.contBSD}>
          <h3 className={styles.bsdT}>BSD SCORE</h3>
          <h1 className={styles.score}>{userData?.scores?.[0]?.valor ?? 0}</h1>
        </div>
      </div>
    </div>
  );
};

export default Escudo;
